import type { Dispatch, SetStateAction } from 'react'
import { Path } from 'react-router'
import type { AvailableFilter, ActiveFilter } from '../../components/DataSelectionLegacy/types'
import createNamedContext from '../createNamedContext'

import { DataSelectionFilters } from '../../components/DataSelection/utils/queryParams'

type Action<T extends keyof DataSelectionContextProps> = Dispatch<
  SetStateAction<DataSelectionContextProps[T]>
>

export interface DataSelectionContextProps {
  availableFilters: AvailableFilter[]
  addFilter: (filter: DataSelectionFilters) => void
  removeFilter: (key: string) => void
  totalResults: number
  activeFilters: ActiveFilter[]
  setTotalResults: Action<'totalResults'>
  setAvailableFilters: Action<'availableFilters'>
  buildFilterLocationDescriptor: ({
    filtersToAdd,
    filtersToRemove,
  }: {
    filtersToAdd?: DataSelectionFilters
    filtersToRemove?: string[]
  }) => Partial<Path>
}

export const DataSelectionContext = createNamedContext<DataSelectionContextProps | null>(
  'DataSelection',
  null,
)
